export class AuthLoginResultDTO {
    
    token: string;

    enforcePasswordChange?: boolean;

    enforceTwofactor?: boolean;

    offerTour?: boolean;

}
